import type { ElementType, RefCallback } from "react";
import { createContext, useContext } from "react";

import { isSameComponentType } from "../utils/elementType";

export type PopupAnchor = {
  ref: RefCallback<Element>;
  props: Record<string, unknown>;
};

type PopupAnchorContextValue = { triggerType: unknown; anchor: PopupAnchor };

export const PopupAnchorContext = createContext<PopupAnchorContextValue | null>(
  null,
);

/**
 * Lets the component passed directly as a Popup `trigger` pick which of its
 * elements the popup anchors to and listens on. Pass the component's public
 * export; returns null unless that component is the trigger, so descendants
 * of other types never claim the anchor.
 */
export function usePopupAnchor(type: ElementType): PopupAnchor | null {
  const ctx = useContext(PopupAnchorContext);
  return ctx && isSameComponentType(ctx.triggerType, type) ? ctx.anchor : null;
}
